<template>
    <div id="print" v-if="!isEmpty(listCourseQuestion)" class="question_content" @touchmove="touchmove" :style="{'background-color': '#275ba9'}">
        <div class="back_nav" @click="backNav()"><img src="../../assets/back_nav.png"/></div>
        <input id="id_time_out" type="hidden" @click="resetShowGuide()">

        <div v-if="showExitConfirm === 1" class="exit_transition">
            <div class="exit_content">
                <div class="exit_title">完成后，才可以获得星星哦</div>
                <div class="game_action">
                    <div class="game_quit" v-on:click.stop="gameQuitClick">
                        <img src="../../Images/game_quit.png"/>
                        <span>Quit</span>
                    </div>
                    <div class="game_continue" v-on:click.stop="gameContinueClick">
                        <img src="../../Images/game_continue.png"/>
                        <span>Continue</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="transition" v-if="showTransition">
            <div class="back_nav2" v-on:click.stop="gameQuitClick"><img src="../../assets/back_nav.png"/></div>
            <div class="content">
                <div class="content2">
                    <img class="icon" src="@/Images/jili.png"/>
                    <div id="id_star_count" class="text">
                        <span class="success_tip">祝贺完成!</span>
                    </div>
                    <div class="content3">
                        <div class="transition_comeback" v-on:click.stop="gameQuitClick">
                            <img src="@/Images/transition_comeback.png"/>
                        </div>
                        <div class="transition_next" v-on:click.stop="gameQuitClick">
                            <span>完成</span>
                            <img src="@/assets/chevron-thin-right.png"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--拖拽题(左右结构)-->
        <div class="drop_question_content">
            <input id="dp_old_top" type="hidden">
            <input id="dp_reset_option_place" type="hidden" @click="resetOptionPlace()">
            <input id="dp_question_answer" type="hidden">
            <input id="input_cl_answer" type="hidden" value="" />
            <input id="input_tempoption_array" type="hidden" :value="JSON.stringify(tempOptionArray)"/>

            <div class="dp_question_sty">
                <div class="dp_question_title_sty">
                    <div class="dp_question_title">
                        <div class="c_audio_play" @click="common_playAudio()">
                            <div class="audio_playing_game img_play" :style="{display: isPlaying ? '' : 'none'}"></div>
                            <img class="img_play" :style="{display: isPlaying ? 'none' : ''}" src="@/Images/audio_game3.png" height="40px" width="40px"/>
                        </div>
                        <div class="dp_question_title_c">{{languageType === 2 ? currentCourseQuestion.chineseText : currentCourseQuestion.text}}</div>
                        <div class="dp_question_chinesetitle" @click="changeLanguageClick">
                            <img :src="getLanguageButton()"/>
                        </div>
                    </div>
                </div>
                <img id="question" :src="geneNetworkPicture(currentCourseQuestion.picture)" alt=""/>
                <img class="dpu_question_sty_img" v-for="(itemOption, indexOption) in listSelectOption" :key="'select_option_' + indexOption"
                     :style="{width:itemOption.width + 'px', height:itemOption.height + 'px', top:itemOption.top + 'px', left:itemOption.left + 'px'}"
                     :src="geneNetworkPicture(itemOption.picture)" alt="" />
                <div id="order_question_tip" style="display: none"><img src="../../assets/order_question_tip.png"/></div>
            </div>

            <div class="dp_answer_sty">
                <div v-if="listQuestionOption.length > 3" id="dp_answer_changepage" class="dp_answer_changepage_sty">
                    <div class="dp_lastanswer_sty" @click="lastOptionClick">
                        <img src="../../assets/bigcat6_up_arrow.png" style="width:15px; height:15px;"/>
                    </div>
                    <div class="dp_nextanswer_sty" @click="nextOptionClick">
                        <img src="../../assets/bigcat6_down_arrow.png" style="width:15px; height:15px;"/>
                    </div>
                </div>
                <div id="dp_answer" class="dp_answer_content_sty">
                    <img :class="itemOption.isRightAnswer === 0 ? 'answer_error' : ''" :id="'dp_drag_' + indexOption"
                         v-bigcat6drag="{questionType:currentCourseQuestion.type, classifyJson:JSON.stringify(listClassifyResult), listSelectOptionJson:JSON.stringify(listSelectOption), bgWidth:currentCourseQuestion.pictureWidthForCalcCoordinate,
                         optionWidth:getOptionWidth(), optionHeight:getOptionHeight(itemOption.pictureWidth, itemOption.pictureHeight), optionCoordinateJson:JSON.stringify(currentCourseQuestion.rightOptionCoordinateArray),
                          optionRight:35, optionTop:0, optionPadding:10, optionBorderWidth:2, json:JSON.stringify(tempOptionArray), allOption:JSON.stringify(listQuestionOption)}"
                         v-for="(itemOption,indexOption) in tempOptionArray" :key="currentIndex + '_' + indexOption"
                         :style="{right:'10px', top:(10 + indexOption*(getThirdPartHeight()) + getTopPadding(itemOption.pictureWidth, itemOption.pictureHeight)) + 'px', width: getOptionWidth() + 'px', height: getOptionHeight(itemOption.pictureWidth, itemOption.pictureHeight) + 'px', 'pointer-events': 'auto'}" :src="geneNetworkPicture(itemOption.picture)" alt=""/>
                </div>
                <div id="dp_success_tip" style="display:none">
                    <div class="dp_success_tipcontent">
                        <div class="question_summary_img"><img src="../../assets/quiz_noall_right.png"/></div>
                        <div v-if="!isEmpty(currentCourseQuestion.summaryText)" class="question_summary_content">{{currentCourseQuestion.summaryText}}</div>
                        <div class="question_summary_next" @click="nextQuestionForRightClick">
                            <span>next</span>
                            <img src="../../assets/next_question.png"/>
                        </div>
                    </div>
                </div>
            </div>
            <audio :src="dpAudioUrl" id="dp_musicmp3"  style="display: none"  @ended="dp_playNext" @error="dp_playEnded" />
        </div>

        <v-touch v-if="showDropGuide === 1" v-on:swipeleft="resetShowGuide" v-on:swiperight="resetShowGuide" v-on:swipeup="resetShowGuide" v-on:swipedown="resetShowGuide">
            <div id="id_drop_guide" class='popContainer2' @click="closeDropGuideClick"><img src="../../assets/finger.png" alt=""/></div>
        </v-touch>
    </div>
</template>

<script>
    import $ from "jquery";
    import Utils from "@/pages/Program/util2";
    import Vue from "vue";

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top',  (height-width)/2 );
            vPrint.css('left',  0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
        }
    }

    export default {
        data() {
            return {
                lessonId: 0,
                currentIndex: 0,
                screenWidth: document.body.clientWidth,
                listCourseQuestion: [],
                listQuestionOption: [],
                listSelectOption: [],
                currentCourseQuestion:{},
                canPointNextAnswer: true,
                dpAudioUrl: "",
                clOptionWidth: 150,
                clOptionTop: 10,
                clOptionPadding: 10,
                showExitConfirm: 0,
                pageNum:0,
                tempOptionArray:[],
                isPlaying: false,
                showTransition: false,
                greatAudio:"https://img.xiaohuasheng.cn/great.mp3",
                dragAudio:"https://img.xiaohuasheng.cn/drag_result.mp3",
                goodJobAudio:"https://img.xiaohuasheng.cn/one_star.mp3",
                languageType:1,
                listClassifyResult:[],
                mTimeout:null,
                mChildTimeout:null,
                mDelayTime: 10000,
                showDropGuide: 0,
                finishQuestion:0,
                tempPlayOptionAudio:"",
            }
        },
        methods:{
            cl_GetListClassifyResult() {
                let that = this;
                that.listClassifyResult = [];

                that.currentCourseQuestion.optionArray.forEach((item, index) => {
                    let hasResult = false;

                    // 对正确答案进行分组，同时统计每组总数量
                    if (item.isRightAnswer === 1) {
                        that.listClassifyResult.forEach((resultItem, resultIndex) => {
                            if (resultItem.x === item.coordinateX && resultItem.y === item.coordinateY) {
                                resultItem.totalCount += 1;
                                Vue.set(that.listClassifyResult, resultIndex, resultItem);
                                hasResult = true;
                            }
                        });

                        if (!hasResult) {
                            let objClassify = {};
                            objClassify.x = item.coordinateX;
                            objClassify.y = item.coordinateY;
                            objClassify.totalCount = 1;
                            objClassify.currentCount = 0;
                            that.listClassifyResult.push(objClassify);
                        }
                    }
                });
            },
            showOrderQuestionTip(optionOrder) {
                let that = this;
                let bgWidth = parseInt(that.currentCourseQuestion.pictureWidthForCalcCoordinate);
                let imgQuestion = document.getElementById('question');
                let divOrderTip = document.getElementById('order_question_tip');
                let scale = imgQuestion.width / bgWidth;
                let showTip = false;

                for (let i = 0; i < that.currentCourseQuestion.optionArray.length; i++) {
                    let itemOption = that.currentCourseQuestion.optionArray[i];
                    let isRightAnswer = parseInt(itemOption.isRightAnswer);

                    if (isRightAnswer === 1 && optionOrder ===  parseInt(itemOption.optionOrder)) {
                        let fillingType = parseInt(itemOption.fillingType);
                        let rangeWidthOrRadius = parseInt(itemOption.rangeWidthOrRadius) * scale;
                        let currentPointX = itemOption.coordinateX * scale;
                        let currentPointY = itemOption.coordinateY * scale;
                        let rangeHeight = parseInt(itemOption.rangeHeight) * scale;

                        if (fillingType === 1) {
                            divOrderTip.style.width = (2*rangeWidthOrRadius) + 'px';
                            divOrderTip.style.height = (2*rangeWidthOrRadius) + 'px';
                            divOrderTip.style.left = (currentPointX + imgQuestion.offsetLeft - rangeWidthOrRadius) + 'px';
                            divOrderTip.style.top = (currentPointY + imgQuestion.offsetTop - rangeWidthOrRadius) + 'px';
                        } else {
                            divOrderTip.style.width = rangeWidthOrRadius + 'px';
                            divOrderTip.style.height = rangeHeight + 'px';
                            divOrderTip.style.left = (currentPointX + imgQuestion.offsetLeft) + 'px';
                            divOrderTip.style.top = (currentPointY + imgQuestion.offsetTop) + 'px';
                        }

                        showTip = true;
                        break;
                    }
                }

                divOrderTip.style.display = showTip ? "flex" : "none";
            },
            common_playAudio() {
                let that = this;
                that.isPlaying = true;

                let dpmusicMp3 = document.getElementById('dp_musicmp3');
                dpmusicMp3.src = that.dpAudioUrl;
                that.dp_playAudio();
            },
            playDragSound(optionAudio) {
                const pageAudio = document.getElementById('dp_musicmp3');
                pageAudio.src = "https://img.xiaohuasheng.cn/drag_result.mp3";
                pageAudio.play();

                this.tempPlayOptionAudio = optionAudio;
            },
            dp_playNext() {
                let that = this;
                that.dp_playEnded();
                const audioPlayer = document.getElementById('dp_musicmp3');

                if (audioPlayer.src === that.dragAudio && !this.isEmpty(that.tempPlayOptionAudio)) {
                    audioPlayer.src = that.tempPlayOptionAudio;
                    audioPlayer.play();
                    return;
                }

                that.dp_finishedQuestion(audioPlayer.src !== that.greatAudio && audioPlayer.src !== that.goodJobAudio);
            },
            dp_finishedQuestion(isOptionAudio) {
                let that = this;

                if (that.finishQuestion === 1 && isOptionAudio) {
                    const audioPlayer = document.getElementById('dp_musicmp3');
                    audioPlayer.src = that.goodJobAudio;
                    audioPlayer.play();

                    $("#dp_answer_changepage").hide();
                    $("#dp_answer").hide();
                    $("#dp_success_tip").show();

                    $('#dp_success_tip .dp_success_tipcontent .question_summary_img img').animate({
                        width:"100%"
                    }, 500,function(){
                    });
                }
            },
            changeLanguageClick() {
                this.languageType = this.languageType === 1 ? 2 : 1;
            },
            getLanguageButton() {
                return this.languageType === 2 ? require('@/assets/bigcat6_yingwen.png') : require('@/assets/bigcat6_zhongwen.png');
            },
            // 下一题
            nextQuestionForRightClick() {
                let that = this;
                that.nextQuestionClick();
            },
            nextQuestionClick:function () {
                let that = this;

                if (that.currentIndex === that.listCourseQuestion.length - 1) {
                    // 增加过度界面
                    that.showFinishTransition();
                    return;
                }

                that.currentIndex += 1;
                that.switchingQuestion();
            },
            // 上一题
            backQuestionForLeftClick() {
                let that = this;
                that.currentIndex -= 1;
                that.switchingQuestion();
            },
            switchingQuestion() {
                let that = this;
                that.clearGuideTimeout();

                // 只有点下一题，才增加过渡页
                if (that.currentIndex < 0 || that.currentIndex >= that.listCourseQuestion.length) {
                    return;
                }

                that.canPointNextAnswer = true;
                that.initData();
            },
            successNextQuestionTip(hasOptionAudio) {
                let that = this;
                that.finishQuestion = 1;

                if (!hasOptionAudio) {
                    that.dp_finishedQuestion(true);
                }
            },
            showFinishTransition() {
                let that = this;
                that.showTransition = true;
                Utils.$emit('setBigCat5Finished', that.lessonId, 6);

                const greatAudio = document.getElementById('dp_musicmp3');
                greatAudio.src = that.greatAudio;
                greatAudio.play();
            },
            initData:function () {
                let that = this;
                // let vType = that.currentCourseQuestion.type;

                // 切换下一题初始化设置
                $("#dp_question_answer").val("");
                $("#dp_old_top").val("");

                $(".dp_answer_content_sty img").each(function (index, item) {
                    $(item).unbind("click");
                });

                that.pageNum = 0;
                that.listSelectOption = [];
                that.languageType = 1;
                $("#dp_answer_changepage").show();
                $("#dp_answer").show();
                $("#dp_success_tip").hide();
                $('#dp_success_tip .dp_success_tipcontent .question_summary_img img').css('width', '60%');
                $("#order_question_tip").hide();
                $("#input_cl_answer").val("");
                that.listClassifyResult = [];
                that.finishQuestion = 0;

                // 切换下一题
                that.currentCourseQuestion = that.deepCopy(that.listCourseQuestion[this.currentIndex]);
                that.listQuestionOption = that.deepCopy(that.currentCourseQuestion.optionArray);
                // var vTypeNew = that.currentCourseQuestion.type;
                that.getOptionsWithPageNum(that.pageNum);
                that.cl_GetListClassifyResult();

                setTimeout(() => {
                    let screenWidth = $('#print').width();
                    let screenHeight = $('#print').height();
                    let imgViewWidth =  $(".dp_question_sty").width() -  90;
                    let imgViewHeight =  $(".dp_question_sty").height() - 95;

                    let qWidthRatio = imgViewWidth/(that.currentCourseQuestion.pictureWidth*1.0);
                    let qHeightRatio = imgViewHeight/(that.currentCourseQuestion.pictureHeight*1.0);
                    let questionScale = Math.min(qWidthRatio, qHeightRatio);
                    let realPictureWidth = questionScale*that.currentCourseQuestion.pictureWidth;
                    let realPictureHeight = questionScale*that.currentCourseQuestion.pictureHeight;

                    // 高度上下减10，减去标题高度
                    $('#question').css('top', 50 + (screenHeight - 70 - realPictureHeight)/2 + 'px').css('left', (screenWidth - 161 - realPictureWidth)/2 + 'px');

                    // 1拖拽题/2随机拖拽题/3单个分类题/4多个分类题/5顺序拖拽题
                    if (that.currentCourseQuestion.type === 5) {
                        setTimeout(() => {
                            that.showOrderQuestionTip(1);
                        }, 20);
                    }

                    that.dp_initAudioUrl();

                    setTimeout(() => {
                        that.dp_playAudio();
                    }, 200);

                    that.showGuide();
                }, 20);
            },
            // 选项向下移动
            lastOptionClick(){
                let count = Math.ceil(this.listQuestionOption.length / 3);

                if (this.pageNum > 0) {
                    this.pageNum--;
                } else {
                    this.pageNum = count - 1;
                }

                this.getOptionsWithPageNum(this.pageNum);
            },
            // 选项向上移动
            nextOptionClick(){
                let count = Math.ceil(this.listQuestionOption.length / 3);

                if (this.pageNum < count - 1) {
                    this.pageNum++;
                } else {
                    this.pageNum = 0;
                }

                this.getOptionsWithPageNum(this.pageNum);
            },
            getOptionsWithPageNum(pageNum) {
                let that = this;

                if (that.listQuestionOption == null ||
                    that.listQuestionOption.length === 0) {
                    return null;
                }

                if (pageNum > Math.ceil(that.listQuestionOption.length / 3) - 1) {
                    pageNum--;
                }

                let index1 = pageNum*3;
                let index2 = index1 + 1;
                let index3 = index2 + 1;
                let arrayCount = that.listQuestionOption.length;
                let tempArray = [];

                if (index1 < arrayCount) {
                    tempArray.push(that.listQuestionOption[index1]);
                }

                if (index2 < arrayCount) {
                    tempArray.push(that.listQuestionOption[index2]);
                }

                if (index3 < arrayCount) {
                    tempArray.push(that.listQuestionOption[index3]);
                }

                that.tempOptionArray = tempArray;
            },
            backNav:function(){
                this.showExitConfirm = 1;
            },
            gameQuitClick() {
                this.showExitConfirm = 0;
                this.$router.go(-1);
            },
            gameContinueClick() {
                this.showExitConfirm = 0;
            },
            touchmove(e) {
                e.preventDefault();
            },
            resetOptionPlace() {

            },
            getThirdPartHeight:function() {
                let that = this;
                return (that.screenWidth - 20)/3.0;
            },
            getTopPadding:function(width, height) {
                let that = this;
                return (that.getThirdPartHeight() - that.getOptionHeight(width, height))/2.0;
            },
            getOptionWidth:function() {
                return 106;
            },
            getOptionHeight:function(width, height) {
                let that = this;
                return that.getOptionWidth() * height / width;
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            dpu_playEnded() {
                var musicMp3 = document.getElementById('dpu_musicMp3');

                if (musicMp3 != null) {
                    musicMp3.pause();
                }
            },
            showLeftRightAnimate:function () {
                let that = this;

                if (that.showDropGuide !== 1) {
                    return;
                }

                $("#id_drop_guide").find("img").animate({right:"150px"},1000,function(){
                    $("#id_drop_guide").find("img").animate({right:"35px"} , 0, that.showLeftRightAnimate);
                });
            },
            showGuide: function () {
                let that = this;

                that.mTimeout = setTimeout(() => {
                    that.showDropGuide = 1;

                    that.mChildTimeout = setTimeout(() => {
                        that.showLeftRightAnimate();
                    }, 200);
                }, that.mDelayTime);
            },
            resetShowGuide: function () {
                let that = this;

                if (that.finishQuestion === 1) {
                    return;
                }

                that.clearGuideTimeout();
                that.showGuide();
            },
            clearGuideTimeout:function () {
                let that = this;
                that.showDropGuide = 0;

                if (that.mTimeout != null) {
                    clearTimeout( that.mTimeout );
                }

                if (that.mChildTimeout != null) {
                    clearTimeout( that.mChildTimeout );
                }
            },
            closeDropGuideClick(){
                this.showDropGuide = 0;
            },
            dp_playEnded() {
                let that = this;
                const pageAudio = document.getElementById('dp_musicmp3');

                if (pageAudio.src !== this.dragAudio) {
                    that.tempPlayOptionAudio = "";
                }

                that.playEnded('dp_musicmp3');
            },
            // 播放完成
            playEnded(idMusicmp3) {
                var musicMp3 = document.getElementById(idMusicmp3);
                let that = this;

                if (!(idMusicmp3 === 'great_audio')) {
                    that.isPlaying = false;
                }

                if (musicMp3 != null) {
                    musicMp3.pause();
                }
            },
            selectRightOption(picture, width, height, left, top, code, coordinateX, coordinateY) {
                let vOption = {};
                vOption.picture = picture;
                vOption.width = width;
                vOption.height = height;
                vOption.left = left;
                vOption.top = top;
                vOption.coordinateX = coordinateX;
                vOption.coordinateY = coordinateY;

                let that = this;
                that.listSelectOption.push(vOption);

                for (let i = 0; i < that.listQuestionOption.length; i++) {
                    let tmpOption = that.listQuestionOption[i];

                    if (tmpOption.code === code) {
                        that.listQuestionOption.splice(i, 1);
                        break;
                    }
                }

                that.tempOptionArray = [];

                setTimeout(() => {
                    that.getOptionsWithPageNum(that.pageNum);
                }, 100);
            },
            dp_initAudioUrl() {
                let that = this;
                that.dpAudioUrl = "";

                if (!that.isEmpty(that.currentCourseQuestion.audio)) {
                    that.dpAudioUrl = that.$qiNiuDomainBase + that.currentCourseQuestion.audio;
                }
            },
            dp_playAudio() {
                let that = this;
                that.playCAudio(that.dpAudioUrl, 'dp_musicmp3');
            },
            // 播放音频
            playCAudio(audioUrl, idMusicMp3) {
                let that = this;

                if (that.isEmpty(audioUrl)) {
                    return;
                }

                let musicMp3 = document.getElementById(idMusicMp3);
                musicMp3.src = audioUrl;
                that.isPlayingFail = false;

                setTimeout(() => {
                    let playPromise = musicMp3.play();
                    that.isPlaying = true;

                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                        }).catch((e) => {
                            let vError = JSON.stringify(e);
                            that.isPlayingFail = true;
                            that.isPlaying = false;

                            if (!that.isEmpty(vError) && vError !== "{}") {
                                window.console.log("播放失败:playAudio:" + vError);
                            }
                        });
                    } else {
                        that.isPlaying = false;
                        window.console.log("播放失败:playAudio");
                    }
                }, 300);
            },
        },
        created() {
            window.resetShowGuide = this.resetShowGuide;
            window.clearGuideTimeout = this.clearGuideTimeout;
            window.successGetStar = this.successGetStar;
            window.successNextQuestionTip = this.successNextQuestionTip;
            window.selectRightOption = this.selectRightOption;
            window.showOrderQuestionTip = this.showOrderQuestionTip;
            window.playDragSound = this.playDragSound;

            this.$nextTick(() => {
                // 禁用右键
                document.oncontextmenu = new Function("event.returnValue=false");
                // 禁用选择
                document.onselectstart = new Function("event.returnValue=false");
            });
        },
        beforeCreate() {
            let that = this;
            let vLessonId = parseInt(that.$route.query.lessonId);
            let url = "/bigCat6/getMindmapQuestion/" + vLessonId;
            that.listSelectOption = [];

            that.$axios.get(url).then((response) => {
                that.listCourseQuestion = response.data;
                window.console.log("getMindmapQuestionP:" + JSON.stringify(response.data));

                that.currentCourseQuestion = that.deepCopy(that.listCourseQuestion[this.currentIndex]);
                that.listQuestionOption = that.deepCopy(that.currentCourseQuestion.optionArray);
                that.getOptionsWithPageNum(that.pageNum);
                that.lessonId = vLessonId;

                that.cl_GetListClassifyResult();
                that.hideStatusAndStopAudio();
                that.dp_initAudioUrl();

                setTimeout(() => {
                    that.dp_playAudio();
                }, 200);

                setTimeout(() => {
                    transformView();

                    setTimeout(() => {
                        let screenWidth = $('#print').width();
                        let screenHeight = $('#print').height();
                        let imgViewWidth =  $(".dp_question_sty").width() -  90;
                        let imgViewHeight =  $(".dp_question_sty").height() - 95;

                        let qWidthRatio = imgViewWidth/(that.currentCourseQuestion.pictureWidth*1.0);
                        let qHeightRatio = imgViewHeight/(that.currentCourseQuestion.pictureHeight*1.0);
                        let questionScale = Math.min(qWidthRatio, qHeightRatio);
                        let realPictureWidth = questionScale*that.currentCourseQuestion.pictureWidth;
                        let realPictureHeight = questionScale*that.currentCourseQuestion.pictureHeight;

                        // 高度上下减10，减去标题高度
                        $('#question').css('top', 50 + (screenHeight - 70 - realPictureHeight)/2 + 'px').css('left', (screenWidth - 161 - realPictureWidth)/2 + 'px');

                        // 1拖拽题/2随机拖拽题/3单个分类题/4多个分类题/5顺序拖拽题
                        if (that.currentCourseQuestion.type === 5) {
                            that.showOrderQuestionTip(1);
                        }

                        that.showGuide();
                    }, 20);
                }, 150);
            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }

    .question_content .first_transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(85, 85, 85, 0.96);
        z-index: 1003;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .question_content .first_content {
        position:relative;
    }

    .question_content .first_transition .first_content img {
        position: absolute;
        width: 79px;
        top: -50px;
        right: 20px;
    }

    .question_content .first_transition .first_content .content {
        background-color: #fef67e;
        width: 400px;
        padding: 20px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
        -moz-border-radius: 15px;
        border: 3px solid rgba(0, 0, 0, 1);
    }

    .question_content .first_transition .first_content .content .text {
        font-size: 16px;
        color: #101010;
    }

    .back_nav {
        position: absolute;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .back_nav img {
        width: 30px;
        height: 30px;
        pointer-events: none;
    }

    .common_audio_play .img_play {
        width: 40px;
        height: 40px;
    }

    .common_audio_play {
        position: absolute;
        display: flex;
        z-index: 999;
        left: 80px;
        top: 15px;
    }
    .common_audio_play img {
        width: 40px;
        height: 40px;
        pointer-events: none;
    }

    .question_content {
        position: relative;
        -webkit-user-select:none;
        -khtml-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
    }

    .dp_question_sty {
        position:absolute;
        margin-top: 10px;
        width: calc(100% - 161px);
        height: calc(100vmin - 20px);
        text-align: center;
    }

    .dp_question_sty #question {
        position:absolute;
        max-width: calc(100% - 90px);
        max-height: calc(100% - 95px);
    }

    .dp_question_sty .dpu_question_sty_img {
        position: absolute;
    }

    .dp_answer_sty {
        position:absolute;
        width: 100%;
        height: 100vmin;
    }

    .dp_answer_changepage_sty {
        position:absolute;
        width: 20px;
        height: 90px;
        background-color: white;
        right: 161px;
        top: 50%;
        -webkit-transform:translateY(-50%);
        border-bottom-left-radius:5px;
        border-top-left-radius: 5px;
        -webkit-border-bottom-left-radius: 5px;
        -webkit-border-top-left-radius: 5px;
        -moz-border-radius-bottomleft: 5px;
        -moz-border-radius-topleft: 5px;
    }

    .dp_answer_changepage_sty .dp_lastanswer_sty {
        position:absolute;
        top: 0;
        width:100%;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .dp_answer_changepage_sty .dp_nextanswer_sty {
        position:absolute;
        bottom: 0;
        width:100%;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .dp_answer_changepage_sty .dp_lastanswer_sty img, .dp_answer_changepage_sty .dp_nextanswer_sty img {
        width:100%;
        pointer-events: none;
    }

    .dp_answer_content_sty {
        position:absolute;
        width: 126px;
        height: 100vmin;
        right: 35px;
        background-color: white;
    }

    .dp_answer_sty .dp_answer_content_sty img {
        position:absolute;
        display: inline-block;
        width: 100%;
    }

    .next_question {
        position:absolute;
        z-index: 999;
        width: 120px;
        height: 40px;
        bottom: 30px;
        background-color:#06A846;
        display: flex;
        align-items: center;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        animation: zoom 1s infinite;
    }

    .next_question .next_question_c {
        margin-left: 20px;
        display: inline-block;
    }

    .next_question .next_question_c span {
        display: inline-block;
        color: white;
        margin-right: 5px;
        font-weight: bold;
        vertical-align: middle;
    }

    .next_question .next_question_c img {
        display: inline-block;
        width: 30px;
        height: 30px;
        vertical-align: middle;
        pointer-events: none;
    }

    .dp_question_title_sty {
        margin-left: 60px;
        width: calc(100% - 60px);
    }
    .dp_question_title_sty .dp_question_title {
        position: relative;
        display: inline-block;
        vertical-align: middle;
        background-color: #00000062;
        color: white;
        width: calc(100% - 80px);
        height: 50px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .dp_question_title_sty .dp_question_title .c_audio_play {
        position: absolute;
        left: -15px;
        display: flex;
        z-index:600;
        margin-top: 10px;
        width: 30px;
        height: 30px;
    }
    .dp_question_title_sty .dp_question_title .c_audio_play .img_play {
        width: 100%;
        height: 100%;
    }
    .dp_question_title_sty .dp_question_title .c_audio_play img {
        width: 100%;
        height: 100%;
        pointer-events: none;
    }
    .dp_question_title_c {
        position: absolute;
        top:50%;
        -webkit-transform: translateY(-50%);
        left:25px;
        width: calc(100% - 50px);
        text-align: left;
        font-size: 16px;
        line-height: 20px;
    }
    .dp_question_chinesetitle {
        position: absolute;
        right: -15px;
        margin-top: 10px;
        width: 30px;
        height: 30px;
        z-index:600;
    }
    .dp_question_chinesetitle img {
        width: 100%;
        height: 100%;
        pointer-events: none;
    }
    .common_question_left2 {
        position: absolute;
        left: 30px;
        bottom: 10px;
    }
    .common_question_left2 img {
        width: 30px;
        height: 30px;
    }
    .common_question_right2 {
        position: absolute;
        right: 190px;
        bottom: 10px;
    }
    .common_question_right2 img {
        width: 30px;
        height: 30px;
    }
    .question_content .exit_transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.9);
        z-index: 1003;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .question_content .exit_content {
        position:relative;
    }
    .question_content .exit_content .exit_title {
        color: white;
        font-size: 18px;
        text-align: center;
        margin-bottom: 50px;
    }
    .question_content .exit_content .game_action .game_quit {
        display: inline-block;
        margin-right: 100px;
    }
    .question_content .exit_content .game_action .game_continue {
        display: inline-block;
    }
    .question_content .exit_content .game_action .game_quit img, .question_content .exit_content .game_action .game_continue img {
        display: block;
        width: 70px;
        margin-bottom: 10px;
        pointer-events: none;
    }
    .question_content .exit_content .game_action .game_quit span, .question_content .exit_content .game_action .game_continue span {
        display: block;
        text-align: center;
        font-size: 20px;
        color: white;
    }
    #dp_success_tip {
        position:absolute;
        width: 126px;
        height: 100vmin;
        right: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    #dp_success_tip .dp_success_tipcontent .question_summary_img {
        text-align: center;
    }

    #dp_success_tip .dp_success_tipcontent .question_summary_img img {
        width: 60%;
        pointer-events: none;
    }
    #dp_success_tip .dp_success_tipcontent .question_summary_content {
        margin-top: 20px;
        background-color: #00000064;
        color: white;
        border-radius: 15px;
        -webkit-border-radius: 15px;
        -moz-border-radius: 15px;
        padding: 10px;
    }
    #dp_success_tip .dp_success_tipcontent .question_summary_next {
        margin-top: 40px;
        display: inline-block;
        background-color: #07A745;
        width: 120px;
        height: 40px;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        animation: zoom 1s infinite;
        text-align: center;
    }
    #dp_success_tip .dp_success_tipcontent .question_summary_next span {
        display: inline-block;
        font-size: 24px;
        line-height: 40px;
        margin-right: 8px;
        color: white;
        vertical-align: middle;
    }
    #dp_success_tip .dp_success_tipcontent .question_summary_next img {
        display: inline-block;
        width: 30px;
        vertical-align: middle;
        pointer-events: none;
    }
    .question_content .transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1002;
    }
    .question_content .transition .content {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100vmin;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .question_content .transition .content2 {
        text-align: center;
    }
    .question_content .transition .content3 {
        text-align: center;
    }
    .question_content .transition .content .icon {
        margin-bottom: 10px;
        width: 35%;
    }
    .question_content .transition .content .text {
        width: 100%;
        margin-top: 5px;
    }
    .question_content .transition .content .text span {
        display: block;
        text-align: center;
    }
    .question_content .transition .content .text .success_tip {
        font-size: 24px;
    }
    .question_content .transition .content .star {
        height: 35px;
    }
    .question_content .transition .content .star .star_item {
        width: 35px;
        height: 35px;
        display: inline-block;
        position: relative;
    }
    .question_content .transition .content .star .star_item img {
        width: 35px;
        height: 35px;
        display: none;
        position: absolute;
        left:50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
        pointer-events: none;
    }
    .question_content .transition .content .text span {
        width: 100%;
        color: white;
        font-size: 12px;
    }
    .back_nav2 {
        position: absolute;
        z-index: 1003;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav2 img {
        width: 30px;
        height: 30px;
        pointer-events: none;
    }
    #order_question_tip {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        animation:blink 1s infinite;
        -webkit-animation:blink 1s infinite;
    }
    #order_question_tip img {
        width: 30px;
        height: 30px;
        pointer-events: none;
    }
    @keyframes blink{
        0%{
            opacity: 0;
        }
        50%{
            opacity: 100;
        }
        100%{
            opacity: 0;
        }
    }
    @-webkit-keyframes blink{
        0%{
            opacity: 0;
        }
        50%{
            opacity: 100;
        }
        100%{
            opacity: 0;
        }
    }
    .popContainer2 {
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .popContainer2 img {
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        right: 35px;
        width: 70px;
    }
    .transition_next {
        margin-top: 30px;
        display: inline-block;
        background-color: #07A745;
        width: 120px;
        height: 40px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        vertical-align: middle;
        animation: zoom 1s infinite;
        text-align: center;
    }
    .transition_next span {
        display: inline-block;
        font-size: 16px;
        color: white;
        line-height: 39px;
        vertical-align: middle;
    }
    .transition_next img {
        display: inline-block;
        width: 15px;
        vertical-align: middle;
    }
    .transition_comeback {
        margin-top: 30px;
        margin-right: 25px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        font-size: 0;
    }
    .transition_comeback img {
        display: inline-block;
        width: 40px;
        height: 40px;
    }
</style>
